import BaseForm from '../base';
export class TotalFlowMetersForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
